import "./root.css";

import React, { useEffect, useState } from "react";

import Router from "pages/router";
import Header from "shared/components/header/header";
import Footer from "shared/components/footer/footer";
import { useAppDispatch } from "config/store";
import { getConfig } from "modules/config/service/config.service";
import { SpbToast, TypeToast } from "shared/components/spb-toast/spb-toast";
import { useSelector } from "react-redux";
import { getRecaptchaPublicKey } from 'modules/config/store/config.selectors';
import {
  getError,
  getMessage,
} from "modules/notification/store/notification.selectors";
import Sidebar from "shared/components/sideBar/sideBar";
import ContentImage from "shared/components/ContentImage/contentImage";
import BottomImage from "shared/components/bottom-image/bottomImage";
import { SpbSpinner } from "shared/components/spb-spinner/spb-spinner";
import { isMobile } from 'react-device-detect';

import { RootState } from "config/reducers";
import { didomiConfig } from "shared/config/didomi";
import { DidomiSDK } from "@didomi/react";
import { blockDevTools } from "shared/util/devtools-util";
export const DidomiContext = React.createContext(null);
export const Root = () => {
  const dispatch = useAppDispatch();

  const [didomiObject, setDidomiObject] = useState(null);
  const [state, setState] = useState<{
    msg: string | undefined;
    title: string;
    type: TypeToast;
  }>({
    msg: undefined,
    title: "MESSAGE",
    type: TypeToast.ERROR,
  });

  const error = useSelector(getError);
  const msg = useSelector(getMessage);
  const getRecaptcha = useSelector(getRecaptchaPublicKey);
  const config = useSelector((state: RootState) => state.config);

  const onDidomiReady = (didomi: any) => {
    setDidomiObject(didomi);
  };

  useEffect(() => {
    dispatch(getConfig());
  }, []);

  useEffect(() => {
    setState({
      msg: error,
      title: "ERROR",
      type: TypeToast.ERROR,
    });
  }, [error]);

  useEffect(() => {
    setState({
      msg,
      title: "INFORMATION",
      type: TypeToast.INFORMATION,
    });
  }, [msg]);
  blockDevTools(config?.profile);
  return (
    <>
      {isMobile ?
        <DidomiContext.Provider value={didomiObject}>
          <div className="page-container position-relative">
            {/* <Sidebar /> */}
            <SpbToast title={state.title} message={state.msg} type={state.type} />

            <Header />
            {/* {getRecaptcha ? */}
            <div className={"content-wrap-mobile position-relative"} data-testid="app-router">
              <ContentImage />

              <Router />

            </div>
            {/* :
              <div className="content-wrap-center" data-testid="app-spinner">
                <SpbSpinner />
              </div>
            } */}
            <Footer />
          </div>
          {config && (
            <DidomiSDK
              config={didomiConfig(config.publicKeyDidomi)}
              iabVersion={2} // If you want to support the TCF v1∏, don't forget to change this value, even if you selected the TCF v2 in the console. This parameter will load the correct stub in the React Component
              noticeId={config.noticeIdDidomi} // If you want to target the notice by ID and not by domain
              gdprAppliesGlobally={true}
              sdkPath="https://sdk.privacy-center.org/"
              embedTCFStub={true}
              onReady={onDidomiReady}
              onConsentChanged={(cwtToken: any) =>
                console.log("A consent has been given/withdrawn", cwtToken)
              }
              onNoticeShown={() => console.log("Didomi Notice Shown")}
              onNoticeHidden={() => console.log("Didomi Notice Hidden")}
            />
          )}
        </DidomiContext.Provider>
        :
        <DidomiContext.Provider value={didomiObject}>
          <div className="page-container position-relative">
            <Sidebar />
            <SpbToast title={state.title} message={state.msg} type={state.type} />

            <Header />
            {/* {getRecaptcha ? */}
            <div className="content-wrap position-relative" data-testid="app-router">
              <ContentImage />

              <Router />


              <div className="position-absolute bottom-0 end-0 imageBox">
                <BottomImage />

              </div>
            </div>
            {/* :
              <div className="content-wrap-center" data-testid="app-spinner">
                <SpbSpinner />
              </div>
            } */}
            <Footer />
          </div>
          {config && (
            <DidomiSDK
              config={didomiConfig(config.publicKeyDidomi)}
              iabVersion={2} // If you want to support the TCF v1∏, don't forget to change this value, even if you selected the TCF v2 in the console. This parameter will load the correct stub in the React Component
              noticeId={config.noticeIdDidomi} // If you want to target the notice by ID and not by domain
              gdprAppliesGlobally={true}
              sdkPath="https://sdk.privacy-center.org/"
              embedTCFStub={true}
              onReady={onDidomiReady}
              onConsentChanged={(cwtToken: any) =>
                console.log("A consent has been given/withdrawn", cwtToken)
              }
              onNoticeShown={() => console.log("Didomi Notice Shown")}
              onNoticeHidden={() => console.log("Didomi Notice Hidden")}
            />
          )}
        </DidomiContext.Provider>
      }
    </>


  );
};

export default Root;
